import { render } from "./EmailRelatedObject.vue?vue&type=template&id=2df7c4a9&scoped=true"
import script from "./EmailRelatedObject.vue?vue&type=script&lang=js"
export * from "./EmailRelatedObject.vue?vue&type=script&lang=js"

import "./EmailRelatedObject.vue?vue&type=style&index=0&id=2df7c4a9&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df7c4a9"]])

export default __exports__